export default {
  company: "会社",
  share_holder: "株主",
  super_senior: "スーパーシニア",
  senior: "シニア",
  master: "マスター",
  agent: "エージェント",
  member: "メンバー",

  account_id: "ユーザー名",
  action: "アクション",
  available_credit: "利用可能クレジット",
  active: "アクティブ",
  account_balance: "口座残高",
  agent_credit: "エージェントクレジット",
  authority: "権限",
  account_information: "アカウント情報",
  account_list: "アカウント一覧",
  audit_by: "監査者",
  add_account: "アカウント追加",
  add_sub_account: "サブアカウント追加",
  authority_option: "権限オプション",
  account: "アカウント",
  access_log: "アクセスログ",
  account_log: "アカウントログ",
  account_details: "アカウント詳細",
  action_by: "アクション実施者",
  away_team_name: "アウェーチーム名",
  amount: "金額",
  account_before_balance: "以前のアカウント残高",
  account_after_balance: "以後のアカウント残高",
  active_bet_list: "アクティブベットリスト",
  agent_win_all: "エージェント全勝",
  agent_win_half: "エージェント半勝",
  agent_lose_all: "エージェント全敗",
  agent_lose_half: "エージェント半敗",
  accumulate_win: "累積勝利",
  add_sub: "サブアカウント追加",
  account_type: "アカウントタイプ",
  account_pt: "アカウントPT",
  account_min: "アカウント最低",
  away_score: "アウェースコア",
  add_secondary_full: "セカンダリーアカウント追加",
  accumulate_balance: "累積残高",
  away: "アウェー",
  aa: "HT: アウェー | FT: アウェー",
  ad: "HT: アウェー | FT: ドロー",
  ah: "HT: アウェー | FT: ホーム",
  anb: "アウェーベットなし",
  all: "全て",
  account_existed: "アカウントが既に存在します",
  account_not_existed: "アカウントが存在しません",
  account_status: "アカウントステータス",
  account_block: "アカウントブロック",
  account_unblock: "アカウントブロック解除",
  add_secondary: "セカンダリーアカウント追加",
  secondary_id_acknowledge_title: "セカンダリーID確認",
  secondary_id_label: "セカンダリーID",
  agent_bulk: "エージェント一括",
  abandoned: "放棄された",
  account_list_alert: "プレイヤーアラート",
  adjustment: "調整",

  balance: "残高",
  bet: "ベット",
  block: "ブロック",
  blocked: "ブロックされた",
  back: "戻る",
  bet_limit: "ベット制限",
  basketball: "バスケットボール",
  baseball: "野球",
  bet_limit_log: "ベット制限ログ",
  browser_agent: "ブラウザーエージェント",
  bet_limit_packages: "ベット制限パッケージ",
  ball: "ボール",
  bet_count: "ベット数",
  bet_type: "ベットタイプ",
  bl: "ベット制限",
  basketball_min_bet: "@:ui.basketball @:ui.min_bet",
  basketball_max_bet: "@:ui.basketball @:ui.max_bet",
  basketball_max_per_match: "@:ui.basketball @:ui.max_per_match",
  baseball_min_bet: "@:ui.baseball @:ui.min_bet",
  baseball_max_bet: "@:ui.baseball @:ui.max_bet",
  baseball_max_per_match: "@:ui.baseball @:ui.max_per_match",
  bet_list: "ベットリスト",
  bet_list_4d: "ベットリスト4D",
  bet_list_esports2: "ベットリストESports2",
  bs: "両方が得点する",

  credit: "クレジット",
  cm: "コミッション",
  close: "閉じる",
  cancel: "キャンセル",
  continue: "続行",
  created_on: "作成日",
  created_by_on: "作成者/日時",
  updated_by_on: "更新者/日時",
  copy_and_create: "コピーして作成",
  copy: "コピー",
  confirm_password: "パスワード確認",
  confirm_security_code: "セキュリティコード確認",
  contact_phone: "電話",
  contact_email: "メール",
  cash_balance: "現金残高",
  currency: "通貨",
  credit_limit: "クレジット制限",
  credit_balance: "クレジット/残高",
  commission: "コミッション",
  correct_score: "正確なスコア",
  correct_score_bl: "正確なスコア (@:ui.soccer)",
  commission_log: "コミッションログ",
  current_balance: "現在の残高",
  cancelled_bet_list: "キャンセルされたベットリスト",
  category: "カテゴリ",
  copy_to_bottom: "下部にコピー",
  comm_sportsbook_hdp_a: "HDP A",
  comm_sportsbook_hdp_b: "HDP B",
  comm_sportsbook_hdp_c: "HDP C",
  comm_sportsbook_hdp_d: "HDP D",
  comm_sportsbook_hdp_e: "HDP E",
  comm_sportsbook_hdp_f: "HDP F",
  comm_sportsbook_hdp_g: "HDP G",
  comm_sportsbook_hdp_h: "HDP H",
  comm_sportsbook_hdp_i: "HDP I",
  comm_sportsbook_hdp_j: "HDP J",
  comm_sportsbook_1x2: "1X2",
  comm_sportsbook_others: "その他",
  comm_sportsbook_hdp_packages: "HDPパッケージ",
  comm_slots: "スロット",
  comm_casino: "ライブカジノ",
  comm_lotto: "ロット",
  comm_keno: "ケノ",
  comm_cockfight: "ESports2",
  comm_lottery_1d: "ロト1D",
  comm_lottery_2d: "ロト2D",
  comm_lottery_3d: "ロト3D",
  comm_lottery_4d: "ロト4D",
  comm_tournament: "トーナメント",
  completed: "完了",
  clean_sheet: "クリーンシート",
  cockfight: "ESports2",
  esports2: "ESports2",
  cockfight_bet_limit_packages: "ESports2ベット制限パッケージ",
  combination: "組み合わせ",
  cs_min_bet: "@:ui.correct_score @:ui.min_bet",
  cs_max_bet: "@:ui.correct_score @:ui.max_bet",
  cs_max_per_match: "@:ui.correct_score @:ui.max_per_match",

  combine: {
    bet_limit_A: "リミット A (@:ui.min = 5 @::ui.max = 250)",
    bet_limit_B: "リミット B (@:ui.min = 10 @::ui.max = 500)",
    bet_limit_C: "リミット C (@:ui.min = 20 @::ui.max = 1000)",
    bet_limit_D: "リミット D (@:ui.min = 200 @::ui.max = 5000)",
    bet_limit_E: "リミット E (@:ui.min = 500 @::ui.max = 10000)",
    bet_limit_F: "リミット F (@:ui.min = 500 @::ui.max = 20000)",
    bet_limit_G: "リミット G (@:ui.min = 500 @::ui.max = 30000)",

    // bet_limit_AUDA: "リミット A (@:ui.min = 1 @::ui.max = 100)",
    // bet_limit_AUDB: "リミット B (@:ui.min = 1 @::ui.max = 125)",
    // bet_limit_AUDC: "リミット C (@:ui.min = 1 @::ui.max = 400)",
    // bet_limit_AUDD: "リミット D (@:ui.min = 5 @::ui.max = 1,500)",
    // bet_limit_AUDE: "リミット E (@:ui.min = 5 @::ui.max = 2,500)",
    // bet_limit_AUDF: "リミット F (@:ui.min = 5 @::ui.max = 5,000)",
    // bet_limit_AUDG: "リミット G (@:ui.min = 5 @::ui.max = 10,000)",

    bet_limit_KRWA: "リミット A (@:ui.min = 1,500 @::ui.max = 200,000)",
    bet_limit_KRWB: "リミット B (@:ui.min = 2,000 @::ui.max = 200,000)",
    bet_limit_KRWC: "リミット C (@:ui.min = 2,000 @::ui.max = 400,000)",
    bet_limit_KRWD: "リミット D (@:ui.min = 4,000 @::ui.max = 800,000)",
    bet_limit_KRWE: "リミット E (@:ui.min = 4,000 @::ui.max = 2,000,000)",
    bet_limit_KRWF: "リミット F (@:ui.min = 4,000 @::ui.max = 4,000,000)",
    bet_limit_KRWG: "リミット G (@:ui.min = 4,000 @::ui.max = 6,000,000)",

    bet_limit_CNYA: "リミット A (@:ui.min = 10 @::ui.max = 500)",
    bet_limit_CNYB: "リミット B (@:ui.min = 10 @::ui.max = 1000)",
    bet_limit_CNYC: "リミット C (@:ui.min = 10 @::ui.max = 2000)",
    bet_limit_CNYD: "リミット D (@:ui.min = 20 @::ui.max = 5000)",
    bet_limit_CNYE: "リミット E (@:ui.min = 20 @::ui.max = 10000)",
    bet_limit_CNYF: "リミット F (@:ui.min = 400 @::ui.max = 20000)",
    bet_limit_CNYG: "リミット G (@:ui.min = 20 @::ui.max = 50000)",

    bet_limit_HKDA: "リミット A (@:ui.min = 5 @::ui.max = 250)",
    bet_limit_HKDB: "リミット B (@:ui.min = 10 @::ui.max = 500)",
    bet_limit_HKDC: "リミット C (@:ui.min = 20 @::ui.max = 1000)",
    bet_limit_HKDD: "リミット D (@:ui.min = 200 @::ui.max = 5000)",
    bet_limit_HKDE: "リミット E (@:ui.min = 500 @::ui.max = 10000)",
    bet_limit_HKDF: "リミット F (@:ui.min = 500 @::ui.max = 20000)",
    bet_limit_HKDG: "リミット G (@:ui.min = 500 @::ui.max = 30000)",

    bet_limit_SGDA: "リミット A (@:ui.min = 1 @::ui.max = 100)",
    bet_limit_SGDB: "リミット B (@:ui.min = 1 @::ui.max = 200)",
    bet_limit_SGDC: "リミット C (@:ui.min = 5 @::ui.max = 500)",
    bet_limit_SGDD: "リミット D (@:ui.min = 5 @::ui.max = 1,000)",
    bet_limit_SGDE: "リミット E (@:ui.min = 10 @::ui.max = 2,000)",
    bet_limit_SGDF: "リミット F (@:ui.min = 5 @::ui.max = 5,000)",
    bet_limit_SGDG: "リミット G (@:ui.min = 5 @::ui.max = 10,000)",
    
    bet_limit_VNDA: "リミット A (@:ui.min = 10 @::ui.max = 2,000)",
    bet_limit_VNDB: "リミット B (@:ui.min = 10 @::ui.max = 3,000)",
    bet_limit_VNDC: "リミット C (@:ui.min = 40 @::ui.max = 5,000)",
    bet_limit_VNDD: "リミット D (@:ui.min = 80 @::ui.max = 25,000)",
    bet_limit_VNDE: "リミット E (@:ui.min = 80 @::ui.max = 50,000)",
    bet_limit_VNDF: "リミット F (@:ui.min = 80 @::ui.max = 100,000)",
    bet_limit_VNDG: "リミット G (@:ui.min = 80 @::ui.max = 150,000)",
	
	bet_limit_MYRA: "リミット A (@:ui.min = 1 @::ui.max = 500)",
    bet_limit_MYRB: "リミット B (@:ui.min = 5 @::ui.max = 500)",
    bet_limit_MYRC: "リミット C (@:ui.min = 10 @::ui.max = 1,000)",
    bet_limit_MYRD: "リミット D (@:ui.min = 10 @::ui.max = 2,500)",
    bet_limit_MYRE: "リミット E (@:ui.min = 100 @::ui.max = 5,000)",
    bet_limit_MYRF: "リミット F (@:ui.min = 500 @::ui.max = 10,000)",
    bet_limit_MYRG: "リミット G (@:ui.min = 500 @::ui.max = 20,000)",
	
	bet_limit_USDA: "リミット A (@:ui.min = 1 @::ui.max = 100)",
    bet_limit_USDB: "リミット B (@:ui.min = 1 @::ui.max = 125)",
    bet_limit_USDC: "リミット C (@:ui.min = 1 @::ui.max = 400)",
    bet_limit_USDD: "リミット D (@:ui.min = 5 @::ui.max = 1,500)",
    bet_limit_USDE: "リミット E (@:ui.min = 5 @::ui.max = 2,500)",
    bet_limit_USDF: "リミット F (@:ui.min = 5 @::ui.max = 5,000)",
    bet_limit_USDG: "リミット G (@:ui.min = 5 @::ui.max = 10,000)",
	
	bet_limit_THBA: "リミット A (@:ui.min = 10 @::ui.max = 2,500)",
    bet_limit_THBB: "リミット B (@:ui.min = 50 @::ui.max = 5,000)",
    bet_limit_THBC: "リミット C (@:ui.min = 100 @::ui.max = 10,000)",
    bet_limit_THBD: "リミット D (@:ui.min = 100 @::ui.max = 50,000)",
    bet_limit_THBE: "リミット E (@:ui.min = 100 @::ui.max = 100,000)",
    bet_limit_THBF: "リミット F (@:ui.min = 100 @::ui.max = 200,000)",
    bet_limit_THBG: "リミット G (@:ui.min = 100 @::ui.max = 300,000)",
	
	bet_limit_IDRA: "リミット A (@:ui.min = 5 @::ui.max = 1,000)",
    bet_limit_IDRB: "リミット B (@:ui.min = 20 @::ui.max = 1,500)",
    bet_limit_IDRC: "リミット C (@:ui.min = 20 @::ui.max = 3,000)",
    bet_limit_IDRD: "リミット D (@:ui.min = 25 @::ui.max = 15,000)",
    bet_limit_IDRE: "リミット E (@:ui.min = 25 @::ui.max = 30,000)",
    bet_limit_IDRF: "リミット F (@:ui.min = 25 @::ui.max = 60,000)",
    bet_limit_IDRG: "リミット G (@:ui.min = 25 @::ui.max = 100,000)",

    bet_limit_MMKA: "リミット A (@:ui.min = 1 @::ui.max = 200)",
    bet_limit_MMKB: "リミット B (@:ui.min = 2 @::ui.max = 200)",
    bet_limit_MMKC: "リミット C (@:ui.min = 2 @::ui.max = 500)",
    bet_limit_MMKD: "リミット D (@:ui.min = 2 @::ui.max = 1,000)",
    bet_limit_MMKE: "リミット E (@:ui.min = 4 @::ui.max = 2,000)",
    bet_limit_MMKF: "リミット F (@:ui.min = 4 @::ui.max = 5,000)",
    bet_limit_MMKG: "リミット G (@:ui.min = 4 @::ui.max = 10,000)",
    
    bet_limit_MMOA: "リミット A (@:ui.min = 1 @::ui.max = 200)",
    bet_limit_MMOB: "リミット B (@:ui.min = 2 @::ui.max = 200)",
    bet_limit_MMOC: "リミット C (@:ui.min = 2 @::ui.max = 500)",
    bet_limit_MMOD: "リミット D (@:ui.min = 2 @::ui.max = 1,000)",
    bet_limit_MMOE: "リミット E (@:ui.min = 4 @::ui.max = 2,000)",
    bet_limit_MMOF: "リミット F (@:ui.min = 4 @::ui.max = 5,000)",
    bet_limit_MMOG: "リミット G (@:ui.min = 4 @::ui.max = 10,000)",

    bet_limit_ARSA: "リミット A (@:ui.min = 5 @::ui.max = 250)",
    bet_limit_ARSB: "リミット B (@:ui.min = 10 @::ui.max = 500)",
    bet_limit_ARSC: "リミット C (@:ui.min = 20 @::ui.max = 1,000)",
    bet_limit_ARSD: "リミット D (@:ui.min = 200 @::ui.max = 5,000)",
    bet_limit_ARSE: "リミット E (@:ui.min = 500 @::ui.max = 10,000)",
    bet_limit_ARSF: "リミット F (@:ui.min = 500 @::ui.max = 20,000)",
    bet_limit_ARSG: "リミット G (@:ui.min = 500 @::ui.max = 30,000)",
    bet_limit_AUDA: "リミット A (@:ui.min = 5 @::ui.max = 250)",
    bet_limit_AUDB: "リミット B (@:ui.min = 10 @::ui.max = 500)",
    bet_limit_AUDC: "リミット C (@:ui.min = 20 @::ui.max = 1,000)",
    bet_limit_AUDD: "リミット D (@:ui.min = 200 @::ui.max = 5,000)",
    bet_limit_AUDE: "リミット E (@:ui.min = 500 @::ui.max = 10,000)",
    bet_limit_AUDF: "リミット F (@:ui.min = 500 @::ui.max = 20,000)",
    bet_limit_AUDG: "リミット G (@:ui.min = 500 @::ui.max = 30,000)",
    bet_limit_BDTA: "リミット A (@:ui.min = 5 @::ui.max = 250)",
    bet_limit_BDTB: "リミット B (@:ui.min = 10 @::ui.max = 500)",
    bet_limit_BDTC: "リミット C (@:ui.min = 20 @::ui.max = 1,000)",
    bet_limit_BDTD: "リミット D (@:ui.min = 200 @::ui.max = 5,000)",
    bet_limit_BDTE: "リミット E (@:ui.min = 500 @::ui.max = 10,000)",
    bet_limit_BDTF: "リミット F (@:ui.min = 500 @::ui.max = 20,000)",
    bet_limit_BDTG: "リミット G (@:ui.min = 500 @::ui.max = 30,000)",
    bet_limit_BNDA: "リミット A (@:ui.min = 5 @::ui.max = 250)",
    bet_limit_BNDB: "リミット B (@:ui.min = 10 @::ui.max = 500)",
    bet_limit_BNDC: "リミット C (@:ui.min = 20 @::ui.max = 1,000)",
    bet_limit_BNDD: "Limit D (@:ui.min = 200 @::ui.max = 5,000)",
    bet_limit_BNDE: "リミット E (@:ui.min = 500 @::ui.max = 10,000)",
    bet_limit_BNDF: "リミット F (@:ui.min = 500 @::ui.max = 20,000)",
    bet_limit_BNDG: "リミット G (@:ui.min = 500 @::ui.max = 30,000)",
    bet_limit_BRLA: "リミット A (@:ui.min = 5 @::ui.max = 250)",
    bet_limit_BRLB: "リミット B (@:ui.min = 10 @::ui.max = 500)",
    bet_limit_BRLC: "リミット C (@:ui.min = 20 @::ui.max = 1,000)",
    bet_limit_BRLD: "リミット D (@:ui.min = 200 @::ui.max = 5,000)",
    bet_limit_BRLE: "リミット E (@:ui.min = 500 @::ui.max = 10,000)",
    bet_limit_BRLF: "リミット F (@:ui.min = 500 @::ui.max = 20,000)",
    bet_limit_BRLG: "リミット G (@:ui.min = 500 @::ui.max = 30,000)",
    bet_limit_EURA: "リミット A (@:ui.min = 5 @::ui.max = 250)",
    bet_limit_EURB: "リミット B (@:ui.min = 10 @::ui.max = 500)",
    bet_limit_EURC: "リミット C (@:ui.min = 20 @::ui.max = 1,000)",
    bet_limit_EURD: "リミット D (@:ui.min = 200 @::ui.max = 5,000)",
    bet_limit_EURE: "リミット E (@:ui.min = 500 @::ui.max = 10,000)",
    bet_limit_EURF: "リミット F (@:ui.min = 500 @::ui.max = 20,000)",
    bet_limit_EURG: "リミット G (@:ui.min = 500 @::ui.max = 30,000)",
    bet_limit_GOOA: "リミット A (@:ui.min = 5 @::ui.max = 250)",
    bet_limit_GOOB: "リミット B (@:ui.min = 10 @::ui.max = 500)",
    bet_limit_GOOC: "リミット C (@:ui.min = 20 @::ui.max = 1,000)",
    bet_limit_GOOD: "リミット D (@:ui.min = 200 @::ui.max = 5,000)",
    bet_limit_GOOE: "リミット E (@:ui.min = 500 @::ui.max = 10,000)",
    bet_limit_GOOF: "リミット F (@:ui.min = 500 @::ui.max = 20,000)",
    bet_limit_GOOG: "リミット G (@:ui.min = 500 @::ui.max = 30,000)",
    bet_limit_INRA: "リミット A (@:ui.min = 5 @::ui.max = 250)",
    bet_limit_INRB: "リミット B (@:ui.min = 10 @::ui.max = 500)",
    bet_limit_INRC: "リミット C (@:ui.min = 20 @::ui.max = 1,000)",
    bet_limit_INRD: "リミット D (@:ui.min = 200 @::ui.max = 5,000)",
    bet_limit_INRE: "リミット E (@:ui.min = 500 @::ui.max = 10,000)",
    bet_limit_INRF: "リミット F (@:ui.min = 500 @::ui.max = 20,000)",
    bet_limit_INRG: "リミット G (@:ui.min = 500 @::ui.max = 30,000)",
    bet_limit_JPYA: "リミット A (@:ui.min = 5 @::ui.max = 250)",
    bet_limit_JPYB: "リミット B (@:ui.min = 10 @::ui.max = 500)",
    bet_limit_JPYC: "リミット C (@:ui.min = 20 @::ui.max = 1,000)",
    bet_limit_JPYD: "リミット D (@:ui.min = 200 @::ui.max = 5,000)",
    bet_limit_JPYE: "リミット E (@:ui.min = 500 @::ui.max = 10,000)",
    bet_limit_JPYF: "リミット F (@:ui.min = 500 @::ui.max = 20,000)",
    bet_limit_JPYG: "リミット G (@:ui.min = 500 @::ui.max = 30,000)",
    bet_limit_NPRA: "リミット A (@:ui.min = 5 @::ui.max = 250)",
    bet_limit_NPRB: "リミット B (@:ui.min = 10 @::ui.max = 500)",
    bet_limit_NPRC: "リミット C (@:ui.min = 20 @::ui.max = 1,000)",
    bet_limit_NPRD: "リミット D (@:ui.min = 200 @::ui.max = 5,000)",
    bet_limit_NPRE: "リミット E (@:ui.min = 500 @::ui.max = 10,000)",
    bet_limit_NPRF: "リミット F (@:ui.min = 500 @::ui.max = 20,000)",
    bet_limit_NPRG: "リミット G (@:ui.min = 500 @::ui.max = 30,000)",
    bet_limit_PKRA: "リミット A (@:ui.min = 5 @::ui.max = 250)",
    bet_limit_PKRB: "リミット B (@:ui.min = 10 @::ui.max = 500)",
    bet_limit_PKRC: "リミット C (@:ui.min = 20 @::ui.max = 1,000)",
    bet_limit_PKRD: "リミット D (@:ui.min = 200 @::ui.max = 5,000)",
    bet_limit_PKRE: "リミット E (@:ui.min = 500 @::ui.max = 10,000)",
    bet_limit_PKRF: "リミット F (@:ui.min = 500 @::ui.max = 20,000)",
    bet_limit_PKRG: "リミット G (@:ui.min = 500 @::ui.max = 30,000)",
    bet_limit_TNDA: "リミット A (@:ui.min = 5 @::ui.max = 250)",
    bet_limit_TNDB: "リミット B (@:ui.min = 10 @::ui.max = 500)",
    bet_limit_TNDC: "リミット C (@:ui.min = 20 @::ui.max = 1,000)",
    bet_limit_TNDD: "リミット D (@:ui.min = 200 @::ui.max = 5,000)",
    bet_limit_TNDE: "リミット E (@:ui.min = 500 @::ui.max = 10,000)",
    bet_limit_TNDF: "リミット F (@:ui.min = 500 @::ui.max = 20,000)",
    bet_limit_TNDG: "リミット G (@:ui.min = 500 @::ui.max = 30,000)",
    bet_limit_USTA: "リミット A (@:ui.min = 5 @::ui.max = 250)",
    bet_limit_USTB: "リミット B (@:ui.min = 10 @::ui.max = 500)",
    bet_limit_USTC: "リミット C (@:ui.min = 20 @::ui.max = 1,000)",
    bet_limit_USTD: "リミット D (@:ui.min = 200 @::ui.max = 5,000)",
    bet_limit_USTE: "リミット E (@:ui.min = 500 @::ui.max = 10,000)",
    bet_limit_USTF: "リミット F (@:ui.min = 500 @::ui.max = 20,000)",
    bet_limit_USTG: "リミット G (@:ui.min = 500 @::ui.max = 30,000)",
    bet_limit_PHPA: "リミット A (@:ui.min = 5 @::ui.max = 250)",
    bet_limit_PHPB: "リミット B (@:ui.min = 10 @::ui.max = 500)",
    bet_limit_PHPC: "リミット C (@:ui.min = 20 @::ui.max = 1,000)",
    bet_limit_PHPD: "リミット D (@:ui.min = 200 @::ui.max = 5,000)",
    bet_limit_PHPE: "リミット E (@:ui.min = 500 @::ui.max = 10,000)",
    bet_limit_PHPF: "リミット F (@:ui.min = 500 @::ui.max = 20,000)",
    bet_limit_PHPG: "リミット G (@:ui.min = 500 @::ui.max = 30,000)",
    bet_limit_LAKA: "リミット A (@:ui.min = 5 @::ui.max = 250)",
    bet_limit_LAKB: "リミット B (@:ui.min = 10 @::ui.max = 500)",
    bet_limit_LAKC: "リミット C (@:ui.min = 20 @::ui.max = 1,000)",
    bet_limit_LAKD: "リミット D (@:ui.min = 200 @::ui.max = 5,000)",
    bet_limit_LAKE: "リミット E (@:ui.min = 500 @::ui.max = 10,000)",
    bet_limit_LAKF: "リミット F (@:ui.min = 500 @::ui.max = 20,000)",
    bet_limit_LAKG: "リミット G (@:ui.min = 500 @::ui.max = 30,000)",
    bet_limit_LKRA: "リミット A (@:ui.min = 5 @::ui.max = 250)",
    bet_limit_LKRB: "リミット B (@:ui.min = 10 @::ui.max = 500)",
    bet_limit_LKRC: "リミット C (@:ui.min = 20 @::ui.max = 1,000)",
    bet_limit_LKRD: "リミット D (@:ui.min = 200 @::ui.max = 5,000)",
    bet_limit_LKRE: "リミット E (@:ui.min = 500 @::ui.max = 10,000)",
    bet_limit_LKRF: "リミット F (@:ui.min = 500 @::ui.max = 20,000)",
    bet_limit_LKRG: "リミット G (@:ui.min = 500 @::ui.max = 30,000)",
    bet_limit_KHRA: "リミット A (@:ui.min = 5 @::ui.max = 250)",
    bet_limit_KHRB: "リミット B (@:ui.min = 10 @::ui.max = 500)",
    bet_limit_KHRC: "リミット C (@:ui.min = 20 @::ui.max = 1,000)",
    bet_limit_KHRD: "リミット D (@:ui.min = 200 @::ui.max = 5,000)",
    bet_limit_KHRE: "リミット E (@:ui.min = 500 @::ui.max = 10,000)",
    bet_limit_KHRF: "リミット F (@:ui.min = 500 @::ui.max = 20,000)",
    bet_limit_KHRG: "リミット G (@:ui.min = 500 @::ui.max = 30,000)",
    bet_limit_AEDA: "リミット A (@:ui.min = 5 @::ui.max = 250)",
    bet_limit_AEDB: "リミット B (@:ui.min = 10 @::ui.max = 500)",
    bet_limit_AEDC: "リミット C (@:ui.min = 20 @::ui.max = 1,000)",
    bet_limit_AEDD: "リミット D (@:ui.min = 200 @::ui.max = 5,000)",
    bet_limit_AEDE: "リミット E (@:ui.min = 500 @::ui.max = 10,000)",
    bet_limit_AEDF: "リミット F (@:ui.min = 500 @::ui.max = 20,000)",
    bet_limit_AEDG: "リミット G (@:ui.min = 500 @::ui.max = 30,000)",
    bet_limit_CADA: "リミット A (@:ui.min = 5 @::ui.max = 250)",
    bet_limit_CADB: "リミット B (@:ui.min = 10 @::ui.max = 500)",
    bet_limit_CADC: "リミット C (@:ui.min = 20 @::ui.max = 1,000)",
    bet_limit_CADD: "リミット D (@:ui.min = 200 @::ui.max = 5,000)",
    bet_limit_CADE: "リミット E (@:ui.min = 500 @::ui.max = 10,000)",
    bet_limit_CADF: "リミット F (@:ui.min = 500 @::ui.max = 20,000)",
    bet_limit_CADG: "リミット G (@:ui.min = 500 @::ui.max = 30,000)",
    bet_limit_CHFA: "リミット A (@:ui.min = 5 @::ui.max = 250)",
    bet_limit_CHFB: "リミット B (@:ui.min = 10 @::ui.max = 500)",
    bet_limit_CHFC: "リミット C (@:ui.min = 20 @::ui.max = 1,000)",
    bet_limit_CHFD: "リミット D (@:ui.min = 200 @::ui.max = 5,000)",
    bet_limit_CHFE: "リミット E (@:ui.min = 500 @::ui.max = 10,000)",
    bet_limit_CHFF: "リミット F (@:ui.min = 500 @::ui.max = 20,000)",
    bet_limit_CHFG: "リミット G (@:ui.min = 500 @::ui.max = 30,000)",
    bet_limit_DKKA: "リミット A (@:ui.min = 5 @::ui.max = 250)",
    bet_limit_DKKB: "リミット B (@:ui.min = 10 @::ui.max = 500)",
    bet_limit_DKKC: "リミット C (@:ui.min = 20 @::ui.max = 1,000)",
    bet_limit_DKKD: "リミット D (@:ui.min = 200 @::ui.max = 5,000)",
    bet_limit_DKKE: "リミット E (@:ui.min = 500 @::ui.max = 10,000)",
    bet_limit_DKKF: "リミット F (@:ui.min = 500 @::ui.max = 20,000)",
    bet_limit_DKKG: "リミット G (@:ui.min = 500 @::ui.max = 30,000)",
    bet_limit_GBPA: "リミット A (@:ui.min = 5 @::ui.max = 250)",
    bet_limit_GBPB: "リミット B (@:ui.min = 10 @::ui.max = 500)",
    bet_limit_GBPC: "リミット C (@:ui.min = 20 @::ui.max = 1,000)",
    bet_limit_GBPD: "リミット D (@:ui.min = 200 @::ui.max = 5,000)",
    bet_limit_GBPE: "リミット E (@:ui.min = 500 @::ui.max = 10,000)",
    bet_limit_GBPF: "リミット F (@:ui.min = 500 @::ui.max = 20,000)",
    bet_limit_GBPG: "リミット G (@:ui.min = 500 @::ui.max = 30,000)",
    bet_limit_MXNA: "リミット A (@:ui.min = 5 @::ui.max = 250)",
    bet_limit_MXNB: "リミット B (@:ui.min = 10 @::ui.max = 500)",
    bet_limit_MXNC: "リミット C (@:ui.min = 20 @::ui.max = 1,000)",
    bet_limit_MXND: "リミット D (@:ui.min = 200 @::ui.max = 5,000)",
    bet_limit_MXNE: "リミット E (@:ui.min = 500 @::ui.max = 10,000)",
    bet_limit_MXNF: "リミット F (@:ui.min = 500 @::ui.max = 20,000)",
    bet_limit_MXNG: "リミット G (@:ui.min = 500 @::ui.max = 30,000)",
    bet_limit_NGNA: "リミット A (@:ui.min = 5 @::ui.max = 250)",
    bet_limit_NGNB: "リミット B (@:ui.min = 10 @::ui.max = 500)",
    bet_limit_NGNC: "リミット C (@:ui.min = 20 @::ui.max = 1,000)",
    bet_limit_NGND: "リミット D (@:ui.min = 200 @::ui.max = 5,000)",
    bet_limit_NGNE: "リミット E (@:ui.min = 500 @::ui.max = 10,000)",
    bet_limit_NGNF: "リミット F (@:ui.min = 500 @::ui.max = 20,000)",
    bet_limit_NGNG: "リミット G (@:ui.min = 500 @::ui.max = 30,000)",
    bet_limit_NOKA: "リミット A (@:ui.min = 5 @::ui.max = 250)",
    bet_limit_NOKB: "リミット B (@:ui.min = 10 @::ui.max = 500)",
    bet_limit_NOKC: "リミット C (@:ui.min = 20 @::ui.max = 1,000)",
    bet_limit_NOKD: "リミット D (@:ui.min = 200 @::ui.max = 5,000)",
    bet_limit_NOKE: "リミット E (@:ui.min = 500 @::ui.max = 10,000)",
    bet_limit_NOKF: "リミット F (@:ui.min = 500 @::ui.max = 20,000)",
    bet_limit_NOKG: "リミット G (@:ui.min = 500 @::ui.max = 30,000)",
    bet_limit_NZDA: "リミット A (@:ui.min = 5 @::ui.max = 250)",
    bet_limit_NZDB: "リミット B (@:ui.min = 10 @::ui.max = 500)",
    bet_limit_NZDC: "リミット C (@:ui.min = 20 @::ui.max = 1,000)",
    bet_limit_NZDD: "リミット D (@:ui.min = 200 @::ui.max = 5,000)",
    bet_limit_NZDE: "リミット E (@:ui.min = 500 @::ui.max = 10,000)",
    bet_limit_NZDF: "リミット F (@:ui.min = 500 @::ui.max = 20,000)",
    bet_limit_NZDG: "リミット G (@:ui.min = 500 @::ui.max = 30,000)",
    bet_limit_RUBA: "リミット A (@:ui.min = 5 @::ui.max = 250)",
    bet_limit_RUBB: "リミット B (@:ui.min = 10 @::ui.max = 500)",
    bet_limit_RUBC: "リミット C (@:ui.min = 20 @::ui.max = 1,000)",
    bet_limit_RUBD: "リミット D (@:ui.min = 200 @::ui.max = 5,000)",
    bet_limit_RUBE: "リミット E (@:ui.min = 500 @::ui.max = 10,000)",
    bet_limit_RUBF: "リミット F (@:ui.min = 500 @::ui.max = 20,000)",
    bet_limit_RUBG: "リミット G (@:ui.min = 500 @::ui.max = 30,000)",
    bet_limit_SEKA: "リミット A (@:ui.min = 5 @::ui.max = 250)",
    bet_limit_SEKB: "リミット B (@:ui.min = 10 @::ui.max = 500)",
    bet_limit_SEKC: "リミット C (@:ui.min = 20 @::ui.max = 1,000)",
    bet_limit_SEKD: "リミット D (@:ui.min = 200 @::ui.max = 5,000)",
    bet_limit_SEKE: "リミット E (@:ui.min = 500 @::ui.max = 10,000)",
    bet_limit_SEKF: "リミット F (@:ui.min = 500 @::ui.max = 20,000)",
    bet_limit_SEKG: "リミット G (@:ui.min = 500 @::ui.max = 30,000)",
    bet_limit_TRYA: "リミット A (@:ui.min = 5 @::ui.max = 250)",
    bet_limit_TRYB: "リミット B (@:ui.min = 10 @::ui.max = 500)",
    bet_limit_TRYC: "リミット C (@:ui.min = 20 @::ui.max = 1,000)",
    bet_limit_TRYD: "リミット D (@:ui.min = 200 @::ui.max = 5,000)",
    bet_limit_TRYE: "リミット E (@:ui.min = 500 @::ui.max = 10,000)",
    bet_limit_TRYF: "リミット F (@:ui.min = 500 @::ui.max = 20,000)",
    bet_limit_TRYG: "リミット G (@:ui.min = 500 @::ui.max = 30,000)",
    bet_limit_ZARA: "リミット A (@:ui.min = 5 @::ui.max = 250)",
    bet_limit_ZARB: "リミット B (@:ui.min = 10 @::ui.max = 500)",
    bet_limit_ZARC: "リミット C (@:ui.min = 20 @::ui.max = 1,000)",
    bet_limit_ZARD: "リミット D (@:ui.min = 200 @::ui.max = 5,000)",
    bet_limit_ZARE: "リミット E (@:ui.min = 500 @::ui.max = 10,000)",
    bet_limit_ZARF: "リミット F (@:ui.min = 500 @::ui.max = 20,000)",
    bet_limit_ZARG: "リミット G (@:ui.min = 500 @::ui.max = 30,000)",
    bet_limit_COPA: "リミット A (@:ui.min = 5 @::ui.max = 250)",
    bet_limit_COPB: "リミット B (@:ui.min = 10 @::ui.max = 500)",
    bet_limit_COPC: "リミット C (@:ui.min = 20 @::ui.max = 1,000)",
    bet_limit_COPD: "リミット D (@:ui.min = 200 @::ui.max = 5,000)",
    bet_limit_COPE: "リミット E (@:ui.min = 500 @::ui.max = 10,000)",
    bet_limit_COPF: "リミット F (@:ui.min = 500 @::ui.max = 20,000)",
    bet_limit_COPG: "リミット G (@:ui.min = 500 @::ui.max = 30,000)",
    bet_limit_PENA: "リミット A (@:ui.min = 5 @::ui.max = 250)",
    bet_limit_PENB: "リミット B (@:ui.min = 10 @::ui.max = 500)",
    bet_limit_PENC: "リミット C (@:ui.min = 20 @::ui.max = 1,000)",
    bet_limit_PEND: "リミット D (@:ui.min = 200 @::ui.max = 5,000)",
    bet_limit_PENE: "リミット E (@:ui.min = 500 @::ui.max = 10,000)",
    bet_limit_PENF: "リミット F (@:ui.min = 500 @::ui.max = 20,000)",
    bet_limit_PENG: "リミット G (@:ui.min = 500 @::ui.max = 30,000)",

    bet_limit_MNTA: "リミット A (@:ui.min = 5 @::ui.max = 250)",
    bet_limit_MNTB: "リミット B (@:ui.min = 10 @::ui.max = 500)",
    bet_limit_MNTC: "リミット C (@:ui.min = 20 @::ui.max = 1,000)",
    bet_limit_MNTD: "リミット D (@:ui.min = 200 @::ui.max = 5,000)",
    bet_limit_MNTE: "リミット E (@:ui.min = 500 @::ui.max = 10,000)",
    bet_limit_MNTF: "リミット F (@:ui.min = 500 @::ui.max = 20,000)",
    bet_limit_MNTG: "リミット G (@:ui.min = 500 @::ui.max = 30,000)",

    bet_limit_KESA: "リミット A (@:ui.min = 5 @::ui.max = 250)",
    bet_limit_KESB: "リミット B (@:ui.min = 10 @::ui.max = 500)",
    bet_limit_KESC: "リミット C (@:ui.min = 20 @::ui.max = 1,000)",
    bet_limit_KESD: "リミット D (@:ui.min = 200 @::ui.max = 5,000)",
    bet_limit_KESE: "リミット E (@:ui.min = 500 @::ui.max = 10,000)",
    bet_limit_KESF: "リミット F (@:ui.min = 500 @::ui.max = 20,000)",
    bet_limit_KESG: "リミット G (@:ui.min = 500 @::ui.max = 30,000)",

    bet_limit_PGKA: "リミット A (@:ui.min = 5 @::ui.max = 250)",
    bet_limit_PGKB: "リミット B (@:ui.min = 10 @::ui.max = 500)",
    bet_limit_PGKC: "リミット C (@:ui.min = 20 @::ui.max = 1,000)",
    bet_limit_PGKD: "リミット D (@:ui.min = 200 @::ui.max = 5,000)",
    bet_limit_PGKE: "リミット E (@:ui.min = 500 @::ui.max = 10,000)",
    bet_limit_PGKF: "リミット F (@:ui.min = 500 @::ui.max = 20,000)",
    bet_limit_PGKG: "リミット G (@:ui.min = 500 @::ui.max = 30,000)",

    bet_limit_SARA: "リミット A (@:ui.min = 5 @::ui.max = 250)",
    bet_limit_SARB: "リミット B (@:ui.min = 10 @::ui.max = 500)",
    bet_limit_SARC: "リミット C (@:ui.min = 20 @::ui.max = 1,000)",
    bet_limit_SARD: "リミット D (@:ui.min = 200 @::ui.max = 5,000)",
    bet_limit_SARE: "リミット E (@:ui.min = 500 @::ui.max = 10,000)",
    bet_limit_SARF: "リミット F (@:ui.min = 500 @::ui.max = 20,000)",
    bet_limit_SARG: "リミット G (@:ui.min = 500 @::ui.max = 30,000)",

    bet_limit_JSTA: "リミット A (@:ui.min = 1 @::ui.max = 500)",
    bet_limit_JSTB: "リミット B (@:ui.min = 5 @::ui.max = 500)",
    bet_limit_JSTC: "リミット C (@:ui.min = 10 @::ui.max = 1,000)",
    bet_limit_JSTD: "リミット D (@:ui.min = 10 @::ui.max = 2,500)",
    bet_limit_JSTE: "リミット E (@:ui.min = 100 @::ui.max = 5,000)",
    bet_limit_JSTF: "リミット F (@:ui.min = 500 @::ui.max = 10,000)",
    bet_limit_JSTG: "リミット G (@:ui.min = 500 @::ui.max = 20,000)",

    bet_limit_lottery_MYRA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_AUDA: "Package A (@:m.D_BIG:15 @:m.D_SMALL:15 SA:6 @:ui.min:1)",
    bet_limit_lottery_CNYA: "Package A (@:m.D_BIG:100 @:m.D_SMALL:100 SA:40 @:ui.min:2)",
    bet_limit_lottery_HKDA: "Package A (@:m.D_BIG:100 @:m.D_SMALL:100 SA:40 @:ui.min:2)",
    bet_limit_lottery_IDRA: "Package A (@:m.D_BIG:150 @:m.D_SMALL:150 SA:60 @:ui.min:3)",
    bet_limit_lottery_KRWA: "Package A (@:m.D_BIG:13000 @:m.D_SMALL:13000 SA:5000 @:ui.min:300)",
    bet_limit_lottery_SGDA: "Package A (@:m.D_BIG:15 @:m.D_SMALL:15 SA:6 @:ui.min:1)",
    bet_limit_lottery_THBA: "Package A (@:m.D_BIG:500 @:m.D_SMALL:500 SA:200 @:ui.min:10)",
    bet_limit_lottery_USDA: "Package A (@:m.D_BIG:10 @:m.D_SMALL:10 SA:5 @:ui.min:1)",
    bet_limit_lottery_VNDA: "Package A (@:m.D_BIG:250 @:m.D_SMALL:250 SA:100 @:ui.min:5)",
    bet_limit_lottery_MMKA: "Package A (@:m.D_BIG:15 @:m.D_SMALL:15 SA:6 @:ui.min:1)",
    bet_limit_lottery_MMOA: "Package A (@:m.D_BIG:15 @:m.D_SMALL:15 SA:6 @:ui.min:1)",

    bet_limit_lottery_ARSA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_BDTA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_BNDA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_BRLA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_EURA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_GOOA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_INRA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_JPYA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_NPRA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_PKRA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_TNDA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_USTA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_PHPA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_LAKA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_LKRA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_KHRA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_AEDA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_CADA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_CHFA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_DKKA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_GBPA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_MXNA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_NGNA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_NOKA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_NZDA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_RUBA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_SEKA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_TRYA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_ZARA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_COPA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_PENA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_MNTA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_KESA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_PGKA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_SARA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_JSTA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",

    comm_limit_A: "グループ A",
    comm_limit_B: "グループ B",
    comm_limit_C: "グループ C",
    comm_limit_D: "グループ D",
    comm_limit_E: "グループ E",
    comm_limit_F: "グループ F",
    comm_limit_G: "グループ G",
    comm_limit_H: "グループ H",
    comm_limit_I: "グループ I",
    comm_limit_J: "グループ J",

    comm_parlay_mmo_a: "パーレイMMO (2-3)",
    comm_parlay_mmo_b: "パーレイMMO (4-12)",

    reset_password: "パスワードをリセットする",
    edit_password: "パスワードを編集する",
    edit_settings: "設定を編集する",
    edit_profile: "プロフィールを編集する",
    edit_authority: "権限を編集する",
    update_commission: "手数料を更新する",
    update_bet_limit: "ベットリミットを更新する",
    update_position_taking: "ポジション取得を更新する",
    update_profile: "プロフィールを更新する"
  },

  downline_id: "ダウンラインID",
  disabled: "無効",
  downline: "ダウンライン",
  dashboard: "ダッシュボード",
  downline_list: "ダウンラインリスト",
  double_chance: "ダブルチャンス",
  downline_credit: "ダウンラインクレジット",
  date: "日付",
  data: "データ",
  date_time: "日付/時間",
  date_range: "日付範囲",
  details: "詳細",
  draw: "ドロー",
  daily_statement: "デイリーステートメント",
  daily_statement_member: "メンバーのステートメント",
  daily_winlose: "日次勝敗",
  daily_winlose_simple: "勝敗シンプル",
  daily_winlose_details: "勝敗詳細",
  daily_reset: "デイリーリセット",
  daily_winlose_platform: "プラットフォーム別勝敗",
  daily_winlose_match: "マッチ別勝敗",
  detail: "詳細",
  downline_outstanding: "ダウンライン未回収",
  dd: "HT: ドロー | FT: ドロー",
  dh: "HT: ドロー | FT: ホーム",
  da: "HT: ドロー | FT: アウェイ",
  dnb: "ドロー・ノー・ベット",
  draw_cancel: "ドロー",
  default: "デフォルト",
  deposit: "入金",

  edit: "編集",
  enter_information: "情報入力",
  enable: "有効",
  esports: "Eスポーツ",
  edit_account: "アカウントを編集",
  edit_limit: "リミットを編集",
  early: "早期",
  event: "イベント",
  enabled: "有効",
  esports_min_bet: "Eスポーツの最小ベット",
  esports_max_bet: "Eスポーツの最大ベット",
  esports_max_per_match: "Eスポーツのマッチ毎最大ベット",
  even: "イベント",
  edited: "編集済み",
  export_excel: "Excelにエクスポート",

  from: "から",
  full: "フル",

  forecast: "予測",
  forecast_soccer: "サッカー予測",
  freeze: "フリーズ",
  full_name: "名前",
  full_mode: "フルモード",
  first_hdp: "1st HDP",
  first_ou: "1st OU",
  fh: "FH",
  forecast_details: "予測詳細",
  full_time: "フルタイム",
  fglg: "@:m.BT_FG/@:m.BT_LG",
  first_goal: "最初のゴール",
  first_half: "前半",
  fold: "折りたたむ",

  grand_total: "総合計",
  gross_commission: "総手数料",
  game_name: "ゲーム名",
  game_provider: "ゲームプロバイダー",
  game_result: "ゲーム結果",
  game_result_details: "ゲーム結果詳細",
  gross_winlose: "総勝敗",
  game_type: "ゲームタイプ",
  game_rules: "スロットゲームのルール",
  game_rules_title1: "",
  game_rules_content1: "",

  ht: "HT",
  half: "ハーフ",
  half_time: "ハーフタイム",
  home: "ホーム",
  hdp: "HDP",
  hdp_packages: "HDPパッケージ",
  home_team_name: "ホームチーム名",
  home_score: "ホームスコア",
  hh: "HT: ホーム | FT: ホーム",
  hd: "HT: ホーム | FT: ドロー",
  ha: "HT: ホーム | FT: アウェイ",
  hdpou: "@:ui.hdp/@:ui.ou",
  htft: "ハーフタイム/フルタイム",
  hnb: "ホーム・ノー・ベット",

  ip_address: "IPアドレス",
  id: "ID",

  jackpot: "ジャックポット",

  key: "キー",
  keno: "ケノ",
  keno_bet_limit_packages: "ケノベットリミットパッケージ",

  log_id: "ログID",
  lottery: "ロト",
  lottery_1d: "ロト 1D",
  lottery_2d: "ロト 2D",
  lottery_3d: "ロト 3D",
  lottery_4d: "ロト 4D",
  lotto: "ロト",
  log: "ログ",
  list: "リスト",
  logs: "ログ",
  login: "ログイン",
  logout: "ログアウト",
  login_ip: "ログイン IP",
  login_id: "ログイン ID",
  last_name: "姓",
  live_casino: "ライブカジノ",
  livecasino: "ライブカジノ",
  lastweek: "先週",
  lastmonth: "先月",
  last3month: "過去3ヶ月",
  league_id: "リーグID",
  league_name: "リーグ名",
  league: "リーグ",
  livecasino_platform: "ライブカジノプラットフォーム",
  livecasino_upline_pt : "ライブカジノ 上位PT",
  livecasino_account_pt : "ライブカジノ アカウントPT",
  livecasino_upline_remaining : "ライブカジノ 上位残高",
  livecasino_account_min : "ライブカジノ アカウント最小",
  livecasino_bet_limit_packages: "ライブカジノベットリミットパッケージ",
  last_goal: "最後のゴール",
  live: "ライブ",
  lose: "敗北",
  lose_half: "半分の敗北",
  last_week: "先週",
  last_month: "先月",
  lotto_bet_limit_packages: "ロトベットリミットパッケージ",
  lottery_bet_limit_packages: "ロトベットリミットパッケージ",

  member_log: "メンバーログ",
  member_balance: "メンバーバランス",
  master_credit: "マスタークレジット",
  member_credit_limit: "メンバークレジットリミット",
  max_credit_limit: "最大クレジットリミット",
  min_max_bet: "最小/最大ベット",
  min_bet: "最小ベット",
  max_bet: "最大ベット",
  max_per_match: "マッチ毎最大ベット",
  mix_parlay: "ミックスパーレイ",
  mmo_parlay: "ミャンマーパーレイ",
  money_line: "マネーライン",
  min: "最小",
  max: "最大",
  market_type: "マーケットタイプ",
  match_time: "マッチタイム",
  match_id: "マッチID",
  member_id: "ユーザー名",
  match: "マッチ",
  master_outstanding: "マスター未回収",
  mode: "モード",
  member_outstanding: "メンバー未回収",
  member_outstanding_4d: "メンバー未回収4D",
  match_result: "マッチ結果",
  messages: "メッセージ",
  message: "メッセージ",
  member_management: "メンバー管理",
  member_bulk: "メンバー一括",
  manila_nocomm: "Onlive & MT & Pretty Gaming & Evolution & Pragmatic & Sexy Gaming Livecasino 0%手数料",
  m4d: "4D",
  marketing_tools: "マーケティングツール",
  min_credit: "最小クレジット",

  new: "新規",
  new_login_id: "新規ログインID",
  new_username: "新規ユーザー名",
  new_password: "新規パスワード",
  new_security_code: "新規セキュリティコード",
  new_account: "新規アカウント",
  next: "次",
  no_goal: "ゴールなし",
  "no/": "No.",
  normal: "通常",
  normal_announcements: "通常のお知らせ",

  on: "ON",
  off: "OFF",
  ok: "OK",
  over: "オーバー",
  overview: "概要",
  old_password: "古いパスワード",
  outstanding: "未回収",
  outstanding_balance: "未回収残高",
  over_under: "オーバー/アンダー",
  odd_even: "奇数/偶数",
  ou: "OU",
  oe: "OE",
  others: "その他",
  odd: "Odd",
  oxt: "1X2",
  outright: "アウトライト",
  others_min_bet: "その他の最小ベット",
  others_max_bet: "その他の最大ベット",
  others_max_per_match: "その他のマッチ毎最大ベット",
  odds_display: "オッズ表示",
  online_player: "オンラインプレイヤー",
  opening_balance: " 開始残高",
  oxtoeml: "OE/1X2/ML",
  oxthdp: "3ウェイハンディキャップ",
  others_sports: "その他のスポーツ",

  pending: "保留",
  platform: "プラットフォーム",
  pt: "ポジション取り",
  password: "パスワード",
  password_rules: "パスワードルール",
  password_rules_intro: "パスワードは以下のルールに従ってください:",
  security_code_rules: "セキュリティコードルール",
  security_code_rules_intro: "セキュリティコードは以下のルールに従ってください:",
  profile_id: "プロフィール ID",
  parent_id: "Parent ID",
  page_size: "ページサイズ",
  profile: "プロフィール",
  payment_option: "支払いオプション",
  part_one: "パート1",
  part_two: "パート2",
  position_taking: "ポジション取り",
  preview_settings: "プレビュー設定",
  preview: "プレビュー",
  parlay: "パーレイ",
  position_taking_log: "ポジション取りログ",
  platform_code: "プラットフォームコード",
  platform_name: "プラットフォーム名",
  pay: "支払う | すべて支払う",
  payout: "支払い",
  product: "製品",
  pending_matches: "保留中のマッチ",
  pt_share: "ポジションシェア",
  platform_settings: "プラットフォーム設定",
  parlay_min_bet: "パーレイの最小ベット",
  parlay_max_bet: "パーレイの最大ベット",
  parlay_max_per_match: "パーレイのマッチ毎最大ベット",
  parlay_upline_pt : "パーレイ 上位PT",
  parlay_account_pt : "パーレイ アカウントPT",
  parlay_upline_remaining : "パーレイ 上位残高",
  parlay_account_min : "パーレイ アカウント最小",
  parlay_mmo_upline_pt : "パーレイMMO 上位PT",
  parlay_mmo_account_pt : "パーレイMMO アカウントPT",
  parlay_mmo_upline_remaining : "パーレイMMO 上位残高",
  parlay_mmo_account_min : "パーレイMMO アカウント最小",
  personal: "個人",
  personal_message: "個人メッセージ",
  password_reset: "パスワードリセット",
  password_update: "パスワード更新",

  refresh: "更新",
  reset: "リセット",
  remaining_credit: "残りのクレジット",
  remaining: "残り",
  rate: "レート",
  report: "レポート",
  running: "実行中",
  remark: "備考",
  refund: "払い戻し",
  range: "範囲",
  reject: "拒否",
  reset_accumulate_win: "累積勝利のリセット",
  refno: "参照番号",
  result: "結果",
  room_1: "パブリック",
  room_2: "プライベート",
  room_3: "パブリック（無料）",

  status: "ステータス",
  succeed: "成功",
  submit: "提出",
  settings: "設定",
  save: "保存",
  search: "検索",
  suspend: "一時停止",
  security_tag: "セキュリティタグ",
  sub_account: "サブアカウント",
  partner_list: "パートナー",
  sports_type: "スポーツタイプ",
  ldiff: "LDiff",
  ldiff_tooltips: "範囲：-0.5〜0.5（小数点以下1桁）",
  margin: "Margin",
  margin_tooltips: "範囲：5〜20（整数のみ）",
  ldiff_margin: "LDiff / Margin",
  ldiff_margin_priority: "優先順位：ベットタイプ > マーケットタイプ > スポーツタイプ",
  ldiff_margin_priority_tooltips: "LDiff / Margin の優先順位は ベットタイプ > マーケットタイプ > スポーツタイプ です。変更を行う際はこの優先順位にご注意ください。",
  partner_showing_for: "表示中",
  partner_showing_for_hint: "下のマーケットタイプとベットタイプはこのスポーツタイプに属します。",
  partner_sport_card_hint: "クリックで選択。ダブルクリックで編集。",
  search_and_copy: "検索とコピー",
  search_existing: "既存の検索",
  skip: "スキップ",
  settings_limit: "設定リミット",
  sportsbook: "スポーツブック",
  slot_games: "スロットゲーム",
  soccer: "サッカー",
  sport_types: "スポーツタイプ",
  settlement: "決済",
  submatch_id: "サブマッチID",
  score: "スコア",
  submatch_code: "サブマッチコード",
  settlement_list: "決済リスト",
  sub_total: "小計",
  settle_amount: "決済額",
  settlement_history: "決済履歴",
  // settlement_member: "メンバー決済詳細",
  sport_type: "スポーツタイプ",
  slot_platform: "スロットプラットフォーム",
  simple_report: "簡易レポート",
  status_update: "ステータス更新",
  set_authority: "権限設定",
  soccer_hdp_upline_pt : "サッカー HDP 上位PT",
  soccer_hdp_account_pt : "サッカー HDP アカウントPT",
  soccer_hdp_upline_remaining : "サッカー HDP 上位残高",
  soccer_hdp_account_min : "サッカー HDP アカウント最小",
  soccer_1x2_upline_pt : "サッカー 1X2 上位PT",
  soccer_1x2_account_pt : "サッカー 1X2 アカウントPT",
  soccer_1x2_upline_remaining : "サッカー 1X2 上位残高",
  soccer_1x2_account_min : "サッカー 1X2 アカウント最小",
  soccer_others_upline_pt : "サッカー その他 上位PT",
  soccer_others_account_pt : "サッカー その他 アカウントPT",
  soccer_others_upline_remaining : "サッカー その他 上位残高",
  soccer_others_account_min : "サッカー その他 アカウント最小",
  hdp_mmo_upline_pt : "HDP MMO 上位PT",
  hdp_mmo_account_pt : "HDP MMO アカウントPT",
  hdp_mmo_upline_remaining : "HDP MMO 上位残高",
  hdp_mmo_account_min : "HDP MMO アカウント最小",
  slots_upline_pt : "スロット 上位PT",
  slots_account_pt : "スロット アカウントPT",
  slots_upline_remaining : "スロット 上位残高",
  slots_account_min : "スロット アカウント最小",
  soccer_min_bet: "サッカー 最小ベット",
  soccer_max_bet: "サッカー 最大ベット",
  soccer_max_per_match: "サッカー マッチ毎最大ベット",
  slots: "スロット",
  security_update: "セキュリティ更新",
  security_code: "セキュリティコード",
  success: "成功",
  stock: "在庫",
  special: "特別",
  special_announcements: "特別なお知らせ",
  seconds: "秒",
  security_disable: "セキュリティ無効",
  select_all: "すべて選択",
  system_parlay: "システムパーレイ",
  settlement_agent_bulk: "決済エージェント一括",
  settlement_agent: "決済エージェント",
  settle_agent: "決済エージェント",
  settlement_member_bulk: "決済メンバー一括",
  settlement_member: "決済メンバー",
  settle_member: "決済メンバー",
  

  schedule_1: "月曜日 | Mon",
  schedule_2: "火曜日 | Tue",
  schedule_3: "水曜日 | Wed",
  schedule_4: "木曜日 | Thu",
  schedule_5: "金曜日 | Fri",
  schedule_6: "土曜日 | Sat",
  schedule_7: "日曜日 | Sun",

  twtn: "勝ちなし",
  total_outstanding: "総未回収額",
  target_id: "ターゲットID",
  target_action: "ターゲットアクション",
  total: "合計",
  types: "タイプ",
  total_goal: "総ゴール",
  tennis: "テニス",
  today: "今日",
  thisweek: "今週",
  thismonth: "今月",
  transaction_log: "取引ログ",
  account_action_log: "アカウントアクションログ",
  total_bet: "総ベット",
  transaction_date: "取引日/時間",
  transfer_method: "振込方法",
  turnover: "売上高",
  total_balance: "総残高",
  total_tran: "総取引",
  total_base: "総メンバー賭け",
  tennis_min_bet: "テニス 最小ベット",
  tennis_max_bet: "テニス 最大ベット",
  tennis_max_per_match: "テニス マッチ毎最大ベット",
  top_winner: "月間トップ10の勝者",
  top_turnover: "月間トップ10の売上高",
  top_loser: "月間トップ10の敗者",
  type: "タイプ",
  total_downline: "総ダウンライン",
  to: "へ",
  transfer: "転送",
  transfer_list: "転送リスト",
  transfer_history: "転送履歴",
  this_month: "今月",
  this_week: "今週",
  total_accepted: "総承認",
  total_rejected: "総拒否",
  total_stake: "総賭け金",
  total_winlose: "総勝敗",
  total_member: "総メンバー",
  tournament: "トーナメント",
  tournament_jackpot: "トーナメントジャックポット",
  tournament_refund_list: "トーナメント払い戻しリスト",

  under: "アンダー",
  upline_id: "上位ID",
  unblock: "ブロック解除",
  update: "更新",
  username: "ユーザー名",
  update_commission_sb: "コミッション スポーツブック",
  update_commission_lc: "コミッション ライブカジノ",
  update_commission_sl: "コミッション スロット",
  update_commission_lo: "コミッション ロト",
  update_commission_kn: "コミッション ケノ",
  update_commission_cf: "コミッション ESports2",
  update_commission_lt: "コミッション 宝くじ",
  update_bet_limit_lc: "ベット制限 ライブカジノ",
  update_bet_limit_sb: "ベット制限 スポーツブック",
  update_bet_limit_lo: "ベット制限 ロト",
  update_bet_limit_kn: "ベット制限 ケノ",
  update_bet_limit_cf: "ベット制限 ESports2",
  update_bet_limit_lt: "ベット制限 宝くじ",
  update_position_sb: "ポジション取り スポーツブック",
  update_position_lc: "ポジション取り ライブカジノ",
  update_position_sl: "ポジション取り スロット",
  update_position_lo: "ポジション取り ロト",
  update_position_kn: "ポジション取り ケノ",
  update_position_cf: "ポジション取り ESports2",
  update_position_lt: "ポジション取り 宝くじ",
  update_account: "アカウント更新",
  update_platform: "プラットフォーム更新",
  upline_pt: "上位PT",
  upline_remaining: "上位残高",
  unblock_profile: "プロフィールのブロック解除",
  unselect_all: "すべて選択解除",

  view_details: "詳細表示",
  view_downline: "ダウンライン表示",
  value: "値",
  valid_turnover: "有効売上高",
  void: "無効",

  winlose_limit: "勝敗制限",
  wallet: "ウォレット",
  winlose: "勝敗",
  win_limit: "勝利制限",
  win_limit_multiplier: "勝利制限乗数",
  win_limit_tooltips: "ライブカジノとスロットのみに適用されます",
  win_limit_tooltips1: "スロットとカジノのAPI遅延により、プレイヤーは勝利制限に達した後も数分間ベットを続けられる場合があります",
  win_limit_0: "無制限",
  win_limit_1: "クレジット制限 x 1",
  win_limit_2: "クレジット制限 x 2",
  win_limit_5: "クレジット制限 x 5",
  win_limit_10: "クレジット制限 x 10",
  win_limit_20: "クレジット制限 x 20",
  winlose_column1: "勝敗",
  winlose_column2: "コミッション",
  winlose_today: "今日の勝敗",
  winlose_yesterday: "昨日の勝敗",
  winner: "勝者",
  won: "勝利",
  win_half: "半勝利",
  withdrawal: "出金",
  
  yesterday: "昨日",
  yesterday_balance: "昨日の残高",

  provider_evo: "Evolution",
  provider_gp: "Game Play",
  provider_vivo: "Vivo suite",
  provider_sa: "SA Gaming",
  provider_ct: "CT855",
  provider_ptg: "Pretty Gaming",
  provider_yb: "Yeebet",
  "provider_pp-c": "Pragmatic",
  provider_lotto: "ロト",
  provider_keno: "ケノ",
  provider_cockfight: "ESports2",
  provider_lottery: "宝くじ",
  provider_ar: "アルカディアゲーミング",
  provider_slots: "スロット (Live22)",
  provider_pgs: "スロット (PGSoft)",
  provider_pp: "スロット (PP)",
  provider_jk: "スロット (Joker)",
  provider_sp: "スロット (SimplePlay)",
  provider_jili: "スロット (Jili)",
  provider_uu: "スロット (UU)",
  provider_db: " (DBHash)",
  provider_wow: "スロット (WOW Gaming)",
  provider_ai: "AI Livecasino",
  provider_wf: "スロット (WF Gaming)",
  provider_next: "スロット (Next)",
  provider_dbp: "ポーカー (DBHash)",
  provider_epw: "スロット (Epicwin)",
  provider_sexybcrt: "Sexy Baccarat",
  provider_bi: "Binary",
  provider_onlive: "Onlive Casino",
  provider_mtlive: "MT Casino",

  timer: "タイマー",
  no_refresh: "リフレッシュしない",
  actual_yesterday_balance: "実際の昨日の残高",

  loading: "ローディング...",
  slide_puzzle: "パズルをスライド",
  drag_to_verify: "ドラッグして確認",
  running_score: "ランニングスコア",
  unblock_account: "アカウントのブロック解除",
  password_expired: "Password Expired",

  lotto_upline_pt : "@:ui.lotto @:ui.upline_pt",
  lotto_account_pt : "@:ui.lotto @:ui.account_pt",
  lotto_upline_remaining : "@:ui.lotto @:ui.upline_remaining",
  lotto_account_min : "@:ui.lotto @:ui.account_min",
  keno_upline_pt : "@:ui.keno @:ui.upline_pt",
  keno_account_pt : "@:ui.keno @:ui.account_pt",
  keno_upline_remaining : "@:ui.keno @:ui.upline_remaining",
  keno_account_min : "@:ui.keno @:ui.account_min",
  cockfight_upline_pt : "@:ui.cockfight @:ui.upline_pt",
  cockfight_account_pt : "@:ui.cockfight @:ui.account_pt",
  cockfight_upline_remaining : "@:ui.cockfight @:ui.upline_remaining",
  cockfight_account_min : "@:ui.cockfight @:ui.account_min",
  lottery_upline_pt : "@:ui.lottery @:ui.upline_pt",
  lottery_account_pt : "@:ui.lottery @:ui.account_pt",
  lottery_upline_remaining : "@:ui.lottery @:ui.upline_remaining",
  lottery_account_min : "@:ui.lottery @:ui.account_min",
  livecasino_tooltips: "カジノベッティングパッケージは、ゲーミングテーブルによって異なる条件が適用される場合があります。",
  notice: "お知らせ",
  // OTP 2FA Translations
  setup_otp_via_mobile_authenticator: "モバイル認証アプリでOTPを設定",
  step_1_download_google_authenticator: "1. デバイスにGoogle Authenticatorをダウンロードしてください。",
  step_2_create_account_scan_qr: "2. Google AuthenticatorでこのQRコードをスキャンしてアカウントを作成してください。",
  step_3_enter_6_digit_code_verify: "3. Google Authenticatorで生成された6桁のコードを下のテキストボックスに入力し、確認をクリックして登録を完了してください。",
  download_on_app_store: "App Storeでダウンロード",
  get_it_on_google_play: "Google Playでダウンロード",
  regenerate_qr: "QRコードを再生成",
  unable_to_scan_qr_code: "QRコードをスキャンできませんか？",
  manual_entry_secret: "手動入力用シークレット",
  otp: "OTP",
  verify: "確認",
  enable_otp_via_mobile_authenticator_app: "モバイル認証アプリでOTPを有効にする",
  two_factor_authenticator_bound: "二要素認証がバインドされています",
  unbind: "バインド解除",
  setup_2fa: "2FAを設定",
  enter_6_digit_code: "6桁のコードを入力",
  verification_code: "確認コード",

  // Telegram OTP Translations
  setup_otp_via_telegram_chatbot: "Telegram ChatbotでOTPを設定",
  step_1_download_telegram: "1. Google Play/App Storeでアプリケーションをダウンロードしてください。",
  step_2_signup_and_generate_qr: "2. 電話番号を使用してTelegramにサインアップしてください。",
  step_3_enable_telegram_bot: "3. Telegram Botを有効にしてください。",
  show_qr_code: "QRコードを表示",
  hide_qr_code: "QRコードを非表示",
  generate_qr_code: "QRコードを生成",
  enable_otp_via_telegram_chatbot: "Telegram ChatbotでOTPを有効にする",
  telegram_bot_bound: "Telegram Botがバインドされています",
  otp_telegram: "OTP Telegram",
  get_otp: "OTPを取得",
  cashout: "出金",
  time_machine: "タイムマシン",
};